import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'reactstrap';

import Layout from 'Layout/Layout';
import { PATHS } from 'config/paths';
import markel from 'assets/images/end_subscription_img.png';
import { withLocale } from '@dietlabs/components';
import withMobileAppMode from 'Layout/withMobileAppMode';
import { callNativeApp } from 'components/Helpers/callNativeApp';
import { formatMediumDate } from 'utils/dateFormatter';

class OutsideAccess extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        mobileAppMode: PropTypes.bool.isRequired,
        renderTimeline: PropTypes.func.isRequired,
        accessTo: PropTypes.oneOfType([
            PropTypes.oneOf([undefined]),
            PropTypes.instanceOf(Date).isRequired,
        ]).isRequired,
        hasActiveSubscription: PropTypes.bool.isRequired,
    };

    renderDate() {
        if (this.props.accessTo) {
            return formatMediumDate(this.props.accessTo);
        }

        return null;
    }

    renderDays() {
        if (this.props.accessTo) {
            const today = new Date();
            const dietAccessEndDate = this.props.accessTo;
            const dietAccesEndDays = Math.ceil(
                (dietAccessEndDate.getTime() - today.getTime()) /
                    (1000 * 60 * 60 * 24)
            );
            return dietAccesEndDays;
        }

        return this.props.t('info-pages/diet-outside-access/unknown-number');
    }

    renderHeading() {
        if (this.props.hasActiveSubscription) {
            return this.props.t('info-pages/diet-outside-access/title', {
                count: this.renderDays(),
                date: this.renderDate(),
            });
        }
        return this.props.t('info-pages/diet-outside-access/web-title', {
            count: this.renderDays(),
            date: this.renderDate(),
        });
    }

    renderAction() {
        if (this.props.mobileAppMode) {
            return (
                <Button
                    color="primary"
                    className="w-100"
                    onClick={() => callNativeApp('/', 'buy-diet')}
                >
                    {this.props.t('button/buy-subscribtion')}
                </Button>
            );
        }

        return (
            <a
                className="btn btn-primary w-100"
                href={`${PATHS.EXTERNAL.HOME}#buy`}
            >
                {this.props.t('purchase')}
            </a>
        );
    }

    render() {
        return (
            <Layout page="diet">
                {this.props.renderTimeline('top')}
                <section className="mt-5 pt-5">
                    <Container className="text-center my-auto">
                        <Row>
                            <Col md={{ size: 6, offset: 3 }}>
                                <img
                                    src={markel}
                                    alt=""
                                    className="img-fluid mb-4"
                                />
                                <h2
                                    data-test="header"
                                    className="title-medium semi-bold"
                                >
                                    {this.renderHeading()}
                                </h2>
                                <p>
                                    {this.props.t(
                                        'error/unauthorized/subscription/expired/content'
                                    )}
                                </p>
                                <p>{this.renderAction()}</p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        );
    }
}

export { OutsideAccess };
export default withMobileAppMode(withLocale(OutsideAccess));
